import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ANALYTICS_RANGE_PRESETS, type AnalyticsRangePreset } from '@repo/shared/marketing';
import { OfferOverviewPage } from '@/features/new-client-offer';
import { DEFAULT_OFFER_OVERVIEW_RANGE } from '@/features/new-client-offer/offer-overview-range';

const DEFAULT_RANGE = DEFAULT_OFFER_OVERVIEW_RANGE;

type OverviewSearch = { range?: AnalyticsRangePreset };

export const Route = createFileRoute('/_auth/$orgId/marketing/new-client-offer/')({
  // The default range stays out of the URL, so the tab link and a bookmark of it are the same page.
  validateSearch: (search: Record<string, unknown>): OverviewSearch => ({
    range:
      typeof search.range === 'string' &&
      (ANALYTICS_RANGE_PRESETS as readonly string[]).includes(search.range) &&
      search.range !== DEFAULT_RANGE
        ? (search.range as AnalyticsRangePreset)
        : undefined,
  }),
  component: OverviewRoute,
});

function OverviewRoute() {
  const { orgId } = Route.useParams();
  const { range } = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/new-client-offer/' });
  return (
    <OfferOverviewPage
      routeOrgId={orgId}
      range={range ?? DEFAULT_RANGE}
      onSelectRange={(next) =>
        void navigate({ search: (previous) => ({ ...previous, range: next === DEFAULT_RANGE ? undefined : next }) })
      }
    />
  );
}
